export default "__VITE_ASSET__9aae4c19__"